import request from '@/utils/request'

// APP版本升级 分页
export function pageappVersion (query) {
  return request({
    url: '/biz/app-version/page',
    method: 'get',
    params: query
  })
}
// APP版本升级 列表
export function listappVersion (query) {
  return request({
    url: '/biz/app-version/list',
    method: 'get',
    params: query
  })
}
// APP版本升级 详情
export function getappVersion (query) {
  return request({
    url: '/biz/app-version/detail',
    method: 'get',
    params: query
  })
}

// APP版本升级 新增
export function addappVersion (data) {
  return request({
    url: '/biz/app-version/add',
    method: 'post',
    data
  })
}

// APP版本升级 编辑
export function editappVersion (data) {
  return request({
    url: '/biz/app-version/edit',
    method: 'post',
    data
  })
}

// APP版本升级 删除
export function delappVersion (data) {
  return request({
    url: '/biz/app-version/delete',
    method: 'post',
    data
  })
}
// APP版本升级 删除
export function update (data) {
  return request({
    url: '/biz/app-version/update',
    method: 'post',
    data
  })
}
